import { render } from "./Backlink.vue?vue&type=template&id=38c59516"
import script from "./Backlink.vue?vue&type=script&lang=js"
export * from "./Backlink.vue?vue&type=script&lang=js"

import "./Backlink.vue?vue&type=style&index=0&id=38c59516&lang=sass"

import exportComponent from "D:\\Open Server 5.3.5\\OSPanel\\domains\\front\\personal_form\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__